import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Dados que coletamos",
    text: "Pelo formulário de demonstração, coletamos: nome, nome do negócio, segmento, WhatsApp e volume mensal de atendimentos. Não coletamos dados sensíveis neste site.",
  },
  {
    title: "2. Como usamos",
    text: "Os dados são usados exclusivamente para entrar em contato sobre a demonstração da CliniAtiva e apresentar a solução para o seu negócio. Nada mais.",
  },
  {
    title: "3. Compartilhamento",
    text: "Não vendemos, alugamos ou compartilhamos seus dados com terceiros para fins de marketing.",
  },
  {
    title: "4. Armazenamento e segurança",
    text: "Os dados ficam armazenados em ambiente seguro e com acesso restrito à equipe comercial da CliniAtiva.",
  },
  {
    title: "5. Seus direitos (LGPD)",
    text: "Conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você pode solicitar a qualquer momento a confirmação, correção ou exclusão dos seus dados.",
  },
  {
    title: "6. Contato",
    text: "Para exercer seus direitos ou tirar dúvidas sobre privacidade, fale com a gente pelo WhatsApp +55 85 9403-2594 ou pelo Instagram @cliniativa.",
  },
];

export const PrivacyLink = ({ className = "", children }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        data-testid="privacy-policy-link"
        onClick={() => setOpen(true)}
        className={className || "underline decoration-[var(--brand)] underline-offset-2 transition-colors duration-300 hover:text-[var(--brand)]"}
      >
        {children || "Política de Privacidade"}
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="privacy-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={() => setOpen(false)}
            className="fixed inset-0 z-[80] flex items-center justify-center bg-navy/70 p-4 backdrop-blur-sm"
          >
            <motion.div
              initial={{ opacity: 0, y: 40, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 40, scale: 0.97 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
              className="grain relative max-h-[78vh] w-full max-w-2xl overflow-y-auto rounded-[28px] bg-petrol p-8 text-white shadow-2xl sm:p-10"
            >
              <div className="relative z-10">
                <div className="flex items-start justify-between gap-6">
                  <div>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-turquoise">CliniAtiva</p>
                    <h3 className="mt-2 font-display text-2xl font-bold sm:text-3xl">Política de Privacidade</h3>
                  </div>
                  <button
                    data-testid="privacy-modal-close"
                    onClick={() => setOpen(false)}
                    aria-label="Fechar política de privacidade"
                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/20 text-white transition-colors duration-300 hover:border-turquoise hover:text-turquoise"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
                <div className="mt-8 space-y-6">
                  {SECTIONS.map((s) => (
                    <div key={s.title}>
                      <h4 className="font-display text-base font-bold text-turquoise">{s.title}</h4>
                      <p className="mt-1.5 text-sm leading-relaxed text-sage/85">{s.text}</p>
                    </div>
                  ))}
                </div>
                <p className="mt-8 border-t border-white/10 pt-5 text-xs text-sage/50">
                  Última atualização: setembro de 2026.
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
